export default __webpack_public_path__ + "locales/en/InfoPanel.json?hash=1ad105bb2fafedaed093ef0b4c34b800";